import { createElementVNode as _createElementVNode, withModifiers as _withModifiers, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "rounded-lg bg-white shadow-lg py-2.5 px-3" }
const _hoisted_2 = { class: "flex mt-1 mb-2" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "flex flex-grow ml-2" }
const _hoisted_5 = { class: "flex justify-between" }
const _hoisted_6 = { class: "text-xs text-gray-400" }
const _hoisted_7 = { class: "mt-2 mb-2 text-sm text-left text-gray-600 whitespace-pre-wrap" }
const _hoisted_8 = { class: "flex items-center" }
const _hoisted_9 = { class: "ml-1 text-xs text-gray-500" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_reaction = _resolveComponent("reaction")!
  const _component_f_icon = _resolveComponent("f-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: "flex-shrink-0 w-10",
        onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleClickAvatar && _ctx.handleClickAvatar(...args)), ["stop"]))
      }, [
        _createElementVNode("img", {
          class: "w-10 h-10 rounded-full",
          src: _ctx.processAvatar(_ctx.comment.creator.avatar)
        }, null, 8, _hoisted_3)
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("span", {
            class: "font-extrabold cursor-pointer text-primary",
            onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleClickAvatar && _ctx.handleClickAvatar(...args)), ["stop"]))
          }, _toDisplayString(_ctx.comment.creator.nickname), 1),
          _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.timeDiff), 1)
        ]),
        _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.comment.content), 1)
      ])
    ]),
    _createElementVNode("div", null, [
      _createVNode(_component_reaction, {
        value: _ctx.mockReaction,
        readonly: false,
        onAdd: _ctx.handleAddReaction,
        onDelete: _ctx.handleDeleteReaction
      }, null, 8, ["value", "onAdd", "onDelete"])
    ]),
    _createElementVNode("div", null, [
      _createElementVNode("span", _hoisted_8, [
        _createVNode(_component_f_icon, {
          name: "edit",
          class: "ml-4 cursor-pointer",
          size: "14",
          onClick: _withModifiers(_ctx.handleClickStar, ["stop"])
        }, null, 8, ["onClick"]),
        _createVNode(_component_f_icon, {
          name: "delete",
          class: "ml-4 cursor-pointer",
          size: "14",
          onClick: _withModifiers(_ctx.handleClickStar, ["stop"])
        }, null, 8, ["onClick"]),
        _createVNode(_component_f_icon, {
          style: _normalizeStyle({color: _ctx.starColor}),
          name: _ctx.comment.starred ? 'heart-fill' : 'heart',
          class: "ml-4 cursor-pointer",
          size: "14",
          onClick: _withModifiers(_ctx.handleClickStar, ["stop"])
        }, null, 8, ["style", "name", "onClick"]),
        _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.comment.starCount), 1)
      ])
    ])
  ]))
}